import type { DownloadAeatDocumentsRequest } from "@/domain/investment";
import type { DownloadAeatFormData } from "@/domain/investment/aeatSelection";
import type { CertificateType } from "@/domain/investment/documentAvailability";

export function getDefaultInvestmentPaymentDeadline(now = new Date()): string | undefined {
  const date = new Date(now);
  date.setDate(date.getDate() + 5);
  return date.toISOString().split("T")[0];
}
export function buildInvestmentDeadlineRequest(templateUuid: string, paymentDeadline: string) {
  return {
    template_uuid: templateUuid.trim(),
    payment_deadline: new Date(paymentDeadline + "T00:00:00Z").toISOString(),
  };
}
export function buildInvestmentReservationExtension(dateInput: string) {
  const date = new Date(dateInput);
  // Retain the legacy local-date to UTC-midnight conversion during rescue.
  return {
    new_expires_at: new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0),
    ).toISOString(),
  };
}
export function buildInvestmentAeatRequest(
  selection: DownloadAeatFormData,
  certificateType: CertificateType,
): DownloadAeatDocumentsRequest {
  return {
    include_communication_contract: selection.include_communication_contract,
    include_financing_contract: selection.include_financing_contract,
    include_certificate: selection.include_certificate,
    certificate_type: selection.include_certificate ? certificateType : null,
  };
}
